module.exports = __webpack_public_path__ + "reduct_Nantes.jpg?d0ac73f41316f792d3a338ca7e3869a1";


//////////////////
// WEBPACK FOOTER
// ./src/img/slider_accueil/reduct/reduct_Nantes.jpg
// module id = 112
// module chunks = 0